import { Grid } from '@material-ui/core';
import { Formik } from 'formik';
import React from 'react';
import { Button, FormText, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Toastr from 'toastr';
import { useDeleteExecutionDataMutation } from '../hooks/useDeleteExecutionDataMutation';
import { DeleteSteps } from '../types';

const DeleteExecModal: React.FC<{
  open: boolean;
  onClose: () => void;
  id: string;
}> = ({ open, onClose, id }) => {
  const deleteSteps = [DeleteSteps.screenshots, DeleteSteps.video]
  const { mutateAsync: deleteExec } = useDeleteExecutionDataMutation((err, msg) => {
    if (err) {
      Toastr.error(msg!)
    } else {
      Toastr.success('Data removed!')
      onClose()
    }
  })
  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalHeader>Delete Execution Data</ModalHeader>
      <Formik
        initialValues={{
          id,
          deleteSteps,
        }}
        validate={values => {
          const errors: Record<string, string | undefined> = {};
          const {
            deleteSteps
          } = values;
          if (deleteSteps.length <= 0) {
            errors.deleteSteps = 'Select at least one.'
          }
          return errors
        }}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await deleteExec({
              deleteSteps: values.deleteSteps,
              id: +id
            })
          } catch (error) {
            console.error(error)
            // Toastr.error(error.message)
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {
          ({
            handleChange,
            handleBlur,
            submitForm,
            values,
            errors,
          }) => (
            <>
              <ModalBody>
                <div className="mb-1">
                  <div className="font-bold mb-1 text-sm">
                    Data to be deleted
                  </div>
                  <Grid container style={{ marginLeft: '21px' }}>
                    {
                      deleteSteps.map((step) => (
                        <Grid xs={4} item key={step}>
                          <Label check key={step}>
                            <Input value={step} css="" type="checkbox" name="deleteSteps" onChange={handleChange} onBlur={handleBlur} checked={values.deleteSteps.includes(step)} />
                            <span className="ml-2">{step[0].toUpperCase()}{step.slice(1)}</span>
                          </Label>
                        </Grid>
                      ))
                    }
                  </Grid>
                  {
                    errors.deleteSteps &&
                    <FormText color="red">
                      {errors.deleteSteps}
                    </FormText>
                  }
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={() => {
                  if (window.confirm('Delete execution data?')) {
                    submitForm()
                  }
                }}>
                  Delete
                </Button>
                <Button onClick={onClose}>
                  Quit
                </Button>
              </ModalFooter>
            </>
          )
        }
      </Formik>
    </Modal>
  )
}

export default DeleteExecModal

